import { type CountryCode } from '@constants'
import { type ValueOf } from '@dni-types/utilities/value-of'
import { type Dispatch, createContext, useContext, type SetStateAction } from 'react'
import { type loginStepGroupBuying } from '../types'

export interface LoginGroupBuyingContextProps {
  setStep: (step: ValueOf<typeof loginStepGroupBuying>) => void
  email?: string
  setEmail: Dispatch<SetStateAction<string>>
  backStep: () => void
  backLoginUrl: string
  fallbackUrl: string
  redirectUrl: string
  tokenLoginUrl: string
  countryCode: CountryCode
  emailDomain: string
}

export const LoginContextGroupBuying = createContext<LoginGroupBuyingContextProps | null>(null)

export function useContextLoginGroupBuying() {
  const loginContext = useContext(LoginContextGroupBuying)

  if (!loginContext) throw new Error('LoginContextGroupBuying has to be used within <LoginContextGroupBuying.Provider>')

  return loginContext
}
